'use client';

import { createContext, useContext } from 'react';

// Context 생성
export const GlobalDataContext = createContext(null);

// Custom Hook (편리하게 사용)
export function useGlobalData() {
  return useContext(GlobalDataContext);
}
